/**
 * Given a box height, compute the relative font size for text within it such
 * that it doesn't look horrible. This is usually used with emojis within a box.
 */
export const computeRelativeFontSize = (size: number): number =>
  // This equation is derived from the parabola defined by three points:
  // (16, 22), (20, 30), (32, 45).
  Math.round(0.0130434782609 * Math.pow(size, 2) - 0.178260869565 * size + 13.6086956522)
